import i18nFactory from '@yandex-int/i18n';
import * as React from 'react';

import { Bem } from '../../service/Bem/Bem';
import { ChangeSource } from '../../typings/graphql-log';
import { UserLogin } from '../UserLogin/UserLogin';

import './LoginCell.css';
import * as keyset from './LoginCell.i18n';

const i18n = i18nFactory(keyset);

export interface Props {
    login?: string;
    tool: ChangeSource;
}

export class LoginCell extends React.PureComponent<Props> {
    render() {
        const { login, tool } = this.props;
        let toolText: string;
        switch (tool) {
            case ChangeSource.API_APP:
                toolText = i18n('api_app');
                break;
            case ChangeSource.COMMANDER:
                toolText = i18n('commander');
                break;
            case ChangeSource.DIRECT_MOBILE_APP:
                toolText = i18n('direct_mobile_app');
                break;
            case ChangeSource.OTHER:
                toolText = i18n('other');
                break;
            case ChangeSource.XLS:
                toolText = i18n('xls');
                break;
            case ChangeSource.WEB:
            default:
                toolText = i18n('web');
                break;
        }

        return (
            <div className={Bem.cls('login-cell')}>
                <div className={Bem.cls('login-cell', 'login')}>
                    <UserLogin login={login} />
                </div>
                <div className={Bem.cls('login-cell', 'tool')}>{toolText}</div>
            </div>
        );
    }
}
